import Lottie from "lottie-react";
import MemegorBlk from "../lottie-loop/mg-icon-loop-black.json";

function Navigation() {
    return (
        <> 
        <div className = "w-full h-screen flex flex-col content-between" > 
            <div className=" w-full px-10 py-10">
                <Lottie animationData={MemegorBlk} loop="true" className="w-32 h-32 " />
            </div>
            <div className=" w-full h-full px-10 py-10">
                <div className="flex flex-col">
                    <div className="">
                        <div className="font-objectsansBold text-md md:h-10 h-12 pb-20">menu</div>

                        <a href="/">
                            <div className="font-objectsansRegular text-lg py-2">Home</div>
                        </a>
                        <a href="/merch">
                            <div className="font-objectsansRegular text-lg py-2">Merch List</div>
                        </a>
                        <a href="/find">
                            <div className="font-objectsansRegular text-lg py-2">Find Us</div>
                        </a>
                        <a href="/about">
                        <div className="font-objectsansRegular text-lg py-2">About US</div>
                        </a>
                    </div>
                </div>
            </div>
            <div className="w-full px-10 py-10">©2022</div>
        </div>
        </>
    )
};

export default Navigation;